<template>
<div class="chapter">
<div class="inner_page">
<p style="text-align:center;margin-bottom:1em;"><b>Praise for <i>The Glory</i> and <i>The Hope</i></b></p>
<p style="text-align:center;"><b><i>The Hope</i></b></p>
<p style="text-align:center;margin-bottom:1em;">A <i>New York Times</i> Bestseller</p>
<p style="text-align:left;margin-top:0.5em">“One of our best writers today—a modern Charles Dickens—is Herman Wouk.… <i>The Hope</i> is not only a good read, but it also causes a good think.”</p><p style="text-align:right;">—<i>The New York Times Magazine</i></p>
<p style="text-align:left;margin-top:0.5em">“Rich and satisfying … deftly portrays the human face of inhuman conflict.”</p><p style="text-align:right;">—<i>The Plain Dealer</i></p>
<p style="text-align:left;margin-top:0.5em">“Seamlessly weaves epic events into everyday life.… Inspiring and full of excitement.”</p><p style="text-align:right;">—<i>Entertainment Weekly</i></p>
<p style="text-align:left;margin-top:0.5em">“Heroic storytelling.… Wouk’s fictional characters humanize history.”</p><p style="text-align:right;">—<i>The Washington Post Book World</i></p>
<p style="text-align:left;margin-top:0.5em">“Herman Wouk is a master of the historical novel.”</p><p style="text-align:right;">—<i>Los Angeles Times</i></p>
<p style="text-align:center;margin-top:0.5em;"><b><i>The Glory</i></b></p>
<p style="text-align:left;margin-top:0.5em">“Superb.… A stirring novel of a brave period and place.… There is historical scope in <i>The Glory</i> that conveys indelibly the sense of history that dignifies the past and sustains the present.”</p><p style="text-align:right;">—<i>The Washington Times</i></p>
<p style="text-align:left;margin-top:0.5em">“Wouk long ago proved his skill at the delicate balancing act which is the historical novel.… He has said that his mission in writing <i>The Hope</i> and <i>The Glory</i> is to give ‘a vivid sense of what it was like to live in that embattled little land’ when these historical events were taking place: he accomplishes what he set out to do, and earns the fireworks that grace his final pages.”</p><p style="text-align:right;">—<i>The Times</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// praise.vue?4f654081